export enum SIGNUP_ADDRESS_PAGE_TYPE {
  MANUAL = 'manual',
  SEARCH = 'search',
}

export enum SIGNUP_CHECKPOINT {
  AFRICA_CREDS = 'Africa-creds',
  AFRICA_OPTIONAL_DEPOSIT = 'Africa-optional-deposit',
  BRAZIL_CHOOSE_FLOW = 'BR-choose-flow',
  BRAZIL_CREDS = 'BR-creds',
  BRAZIL_OPTIONAL_DEPOSIT = 'BR-optional-deposit',
  BRAZIL_OPTIONAL_OPT_IN = 'BR-optional-optIn',
  IOM_CREDS = 'IOM-creds',
  BR_PERSONAL = 'BR-personal',
  IOM_PERSONAL = 'IOM-personal',
  IOM_OPTIONAL_DEPOSIT = 'IOM-optional-deposit',
  UK_CREDS = 'UK-creds',
  UK_PERSONAL = 'UK-personal',
  UK_ACCOUNT_VERIFICATION = 'UK-account-verification',
  UK_SET_DEPOSIT_LIMIT = 'UK-set-deposit-limit',
  UK_REQUIRED_DEPOSIT = 'UK-required-deposit',
  UK_OPTIONAL_OPT_IN = 'UK-optional-optIn',
  IOM_OPTIONAL_OPT_IN = 'IOM-optional-optIn',
}

export enum SIGNUP_TYPE {
  PHONE_VERIFICATION = 'phoneVerification',
  PASSWORD_WITH_CONFIRM = 'passwordWithConfirm',
  TERMS_AND_CONDITIONS = 'TermsAndConditions',
  ALREADY_HAVE_ACCOUNT = 'alreadyHaveAccount',
  HIDDEN = 'hidden',
  EMAIL = 'email',
  MARKETING = 'marketing',
  TEXT = 'text',
  DATE_OF_BIRTH = 'dateOfBirth',
  ADDRESS = 'address',
  GOVERNMENTAL_ID = 'governmentalId',
  PAYMENT_METHODS_AVAILABLE = 'paymentMethodsAvailable',
}

export enum SIGNUP_TEMPLATE {
  CUSTOM = 'custom',
  FIRST_DEPOSIT = 'firstDeposit',
  SET_DEPOSIT_LIMIT = 'setDepositLimit',
  CHOOSE_FLOW = 'chooseFlow',
  OPT_IN = 'optIn',
}

export enum PASSWORD_PATTERN {
  REGULAR = 1,
  FOUR_CHARS = 2,
}

export enum SIGNUP_FLOW {
  BR_NORMAL = 'BR-normal',
  BR_FAST_PIX = 'BR-fast-pix',
}
